"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizedAndOperator = normalizedAndOperator;
/**
 * Generating the And operator for a search, taking searchProvider
 * into account
 */
function normalizedAndOperator(searchProvider) {
    return searchProvider === "typesense" ? "&&" : "AND";
}
//# sourceMappingURL=operationAdapters.js.map